import React, { useEffect, useRef } from 'react';
import { useParams, generatePath, useHistory } from 'react-router-dom';
import { createState, useState, Downgraded } from '@hookstate/core';
import
{
    Box,
    TextField,
    Typography,
    Divider,
    CircularProgress,
    Select,
    MenuItem,
    Button,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEventState } from '../../stores/eventStore';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import RouteConstants from '../../constants/routeConstants';
import { FULL_PERMISSION, VIEW_PERMISSION } from '../../constants/Constant';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import Title from '../../sharedcomponents/title/title';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
// import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import { useAgentState } from '../../hookState/AgentState';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import trash from '../../assets/images/trash.svg';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import Editor from 'ckeditor5-custom-build/build/ckeditor';
import TinyMCEEditor from '../../sharedcomponents/tinymceEditor/tinymce';

const resourceState = createState({
    ResourceName: '',
    eventResourceID: '',
    ResourceUrl: [],
    Description: '',
    IsPublic: 1,
    resourceFile: [],
    oldSrc: [],
    src: [],
    isDisable: false
});
const useStyles = makeStyles({
    mobileLogo: {
        height: 42,
    },
    sedanBlack: {
        height: 18,
        width: 36,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
});

const CreateResource = (props) =>
{
    const classes = useStyles();
    const eventState = useEventState();
    const state = useState(resourceState);
    const agentState = useAgentState();
    const agentInfo = Helper.getStorage('agentInfo');
    const userInfo = Helper.getStorage('userInfo');
    const inputFile = useRef(null)
    const loading = useState(false);
    let params = useParams();
    // const [fileNameArr, setFileNameArr] = React.useState()
    const history = useHistory();
    const [eventResourceID, setEventResourceID] = React.useState(0);
    const [ResourceNameErr, setResourceNameErr] = React.useState('');
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [modPermission, setModPermission] = React.useState(null);
    const [disableBtn, setDisableBtn] = React.useState(true);

    useEffect(() =>
    {
        if (eventState.get() && eventState.eventDetail.get() != null)
        {
            if (!Helper.isAdminUser(userInfo) || !userInfo.roles && Helper.isEventAdmin(userInfo))
            {
                setModPermission(VIEW_PERMISSION);
            } else if (Helper.isAdminUser(userInfo) || userInfo.roles && Helper.isEventAdmin(userInfo))
            {
                setModPermission(FULL_PERMISSION);
            }
        }
    }, [eventState]);
    const handleBtnCancel = () =>
    {
        props.history.goBack();
    };
    useEffect(() =>
    {
        if (modPermission && modPermission == FULL_PERMISSION || modPermission == VIEW_PERMISSION)
        {
            setEventResourceID(params.eventResourceID)

            if (params.eventResourceID)
            {
                if (history.location.state.resourceState)
                {
                    const resourceState = history.location.state.resourceState;
                    setEventResourceID(params.eventResourceID)
                    state.set({
                        ResourceName: resourceState.resourceName,
                        eventResourceID: resourceState.eventResourceID,
                        Description: resourceState.description ? resourceState.description : "",
                        ResourceUrl: resourceState.resourceUrl,
                        resourceFile: resourceState.resourceFile,
                        IsPublic: resourceState.isPublic ? 1 : 0,
                        oldSrc: resourceState.resourceUrl,
                    });
                }
            } else
            {
                resetState();
            }
        }
        // console.log('page==>', state.src.get());        
    }, [params.EventResourceID, modPermission]);


    const resetState = () =>
    {
        state.set({
            ResourceName: '',
            ResourceUrl: '',
            Description: '',
            IsPublic: 1,
            src: '',
        });
    };

    const validateFName = () =>
    {
        let value = state.ResourceName.get().trim();
        if (value === '')
        {
            setResourceNameErr('Please Enter First Name');
            return { flag: 'false', messages: 'Please Enter Resource Name' };
        }
    };
    const handleSubmit = (event) =>
    {
        event.preventDefault();
        const userInfo = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');
        const resourceUrl = [];
        const newFileArray = (state.src.attach(Downgraded).get() ? state.src.attach(Downgraded).get() : []).concat(state.resourceFile.attach(Downgraded).get() ? state.resourceFile.attach(Downgraded).get() : [])

        newFileArray.forEach((file) =>
        {
            // console.log("file", file.fileName);
            resourceUrl.push({
                FileName: file.fileName,
                CreatedBy: userInfo.userID
            });
        });
        let resourceForm = new FormData();
        resourceForm.append('EventID', eventInfo.eventID);
        resourceForm.append('EventResourceID', parseInt(eventResourceID ? eventResourceID : 0));
        resourceForm.append('ResourceName', state.ResourceName.get());
        resourceForm.append('CreatedBy', agentState.visible.value
            ? agentInfo.userID
            : userInfo.userID);
        resourceForm.append('OldSrc', '');
        resourceForm.append('ResourceUrl', '');
        resourceForm.append('Description', state.Description.get() != '' ? encodeURIComponent(state.Description.get()) : state.Description.get());

        resourceForm.append('ResourceFile', JSON.stringify(resourceUrl));
        resourceForm.append('IsPublic', state.IsPublic.get() ? true : false);
        resourceForm.append('OldSource', JSON.stringify(resourceUrl));
        // resourceForm.append('FileSource', state.src.attach(Downgraded).get());
        let newFile = [];
        // let binaryData = '';
        state.src.attach(Downgraded).get() &&
            state.src
                .attach(Downgraded)
                .get()
                .forEach(async (file) =>
                {
                    // console.log("file.file", file.file, i);
                    if (file.file)
                    {
                        newFile.push(file.file)
                        resourceForm.append('FileSource', file.file);
                    }
                });
        // console.log("newFile", newFile);
        loading.set(true);
        state.isDisable.set(false);
        // console.log("resourceForm", resourceForm);

        ApiHelper.post(APIURLConstants.POST_INS_RESOURCE, resourceForm)
            .then((res) =>
            {
                if (res.data !== "")
                {
                    state.isDisable.set(false);
                    if (eventResourceID > 0)
                    {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'success',
                            message: 'Resource updated successfully',
                        });
                    } else
                    {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'success',
                            message: 'Resource added successfully',
                        });
                    }
                    setTimeout(() =>
                    {
                        props.history.push(
                            generatePath(RouteConstants.EVENT_RESOURCE, {
                                eventID: eventInfo.eventID,
                            })
                        );
                    }, 1000);
                    loading.set(false);
                }
            })
            .catch((error) =>
            {
                loading.set(false);
                state.isDisable.set(false);
                console.log('Error : ', error);
                if (error.response && error.response.status === 401)
                {
                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: 'Access denied',
                    });
                } else
                {
                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: 'Error while creating request',
                    });
                }
            });
    };
    const fileUploadHandler = (event) =>
    {
        let file = event.currentTarget.files;
        const files = state.src.attach(Downgraded).get()
            ? [...state.src.attach(Downgraded).get()]
            : [];
        let fileSrcs = state.ResourceUrl.attach(Downgraded).get()
            ? [...state.ResourceUrl.attach(Downgraded).get()]
            : []

        if (file.length > 0)
        {
            // const newFile = new File([blob], file.name.replace(" ", "_"), { type: file.type });
            Array.from(file).forEach((item) =>
            {
                if (item.type === 'application/pdf' || item.type === '.pdf')
                {
                    // const file = item;
                    let blob = item.slice(0, item.size, item.type);
                    let extension = item.name.substring(item.name.lastIndexOf('.') + 1);
                    let fileName = item.name.substring(0, item.name.lastIndexOf('.'));
                    let newFileName = fileName + '_' + new Date().getTime() + '.' + extension;
                    const newFile = new File([blob], newFileName, { type: item.type });
                    // console.log("newFile", newFile);
                    files.push({
                        fileName: newFileName,
                        createdDate:
                            Helper.FormatYearDate(new Date()) +
                            ' ' +
                            Helper.FormatTime24(new Date()),
                        // createdBy: userInfo.attach(Downgraded).get().userID,
                        // isAvailableAtBlob: false,
                        file: newFile,
                    });
                    fileSrcs.push({
                        fileName: newFileName,
                    })
                } else
                {
                    {
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Please Upload only .pdf',
                        });
                    }
                }
            })
            // console.log("files", fileSrcs, files);
            // console.log(state.resourceFile.attach(Downgraded).get())
            if (state.resourceFile.attach(Downgraded).get() && state.resourceFile.attach(Downgraded).get().length > 0)
            {
                state.resourceFile.attach(Downgraded).get().map((item, index) =>
                {
                    handleEditRemove(index)
                })
            }
            if (files.length == 1)
            {
                state.src.set(files)
                state.ResourceUrl.set(fileSrcs);
            }
            else
            {
                state.src.set([files[1]]);
                state.ResourceUrl.set([fileSrcs[1]]);
            }
            handleDisableBtn();
        } else
        {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please Upload only .pdf',
            });
        }
        // }
        //  else
        // {
        //     setSnackBarProps({
        //         ...snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'Please upload file below 50mb',
        //     });
        // }
    };
    const onResourceButtonClick = () =>
    {
        inputFile.current.click();
    };
    const handleRemove = (index) =>
    {
        // console.log(index)
        const values = [...state.attach(Downgraded).get().src];
        values.splice(index, 1);
        state.src.set(values);
        const dt = new DataTransfer();
        const input = document.getElementById('imageUploadFile');
        const { files } = input;
        // console.log(values, "files");
        for (let i = 0; i < files.length; i++)
        {
            const file = files[i];
            if (index !== i) dt.items.add(file); // here you exclude the file. thus removing it.
        }
        input.files = dt.files; // Assign the updates list
        handleDisableBtn()
    };
    const handleEditRemove = (index) =>
    {
        // console.log(index)
        const values = [...state.attach(Downgraded).get().resourceFile];
        values.splice(index, 1);
        state.resourceFile.set(values);
        // console.log("state", state);
        const dt = new DataTransfer();
        const input = document.getElementById('imageUploadFile');
        const { files } = input;
        // console.log(values, "files");
        for (let i = 0; i < files.length; i++)
        {
            const file = files[i];
            if (index !== i) dt.items.add(file); // here you exclude the file. thus removing it.
        }
        input.files = dt.files; // Assign the updates list
        handleDisableBtn();
    };

    const handleDisableBtn = () =>
    {
        if (eventResourceID > 0)
        {
            const resourceState = history.location.state.resourceState;

            const prevData = {
                resourceName: resourceState.resourceName,
                resourceFile: resourceState.resourceFile,
                Description: resourceState.Description,
                IsPublic: resourceState.isPublic ? 1 : 0,
                src: []
            }
            const currentData = {
                resourceName: state.get().ResourceName,
                resourceFile: state.attach(Downgraded).get().resourceFile,
                Description: state.get().Description,
                IsPublic: state.get().IsPublic,
                src: state.attach(Downgraded).get().src != undefined ? state.attach(Downgraded).get().src : []
            };
            // console.log(prevData);
            // console.log(currentData);
            if (JSON.stringify(prevData) === JSON.stringify(currentData))
            {
                setDisableBtn(true)
            } else
            {
                setDisableBtn(false)
            }
        }
    }
    const setEditorValue = (value) => {
        state.Description.set(value);
        handleDisableBtn();
    }
    return (
        <>
            {loading.get() ? (
                <Box className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box
                    component="form"
                    className="contentBox"
                    sx={{
                        width: '100%',
                        backgroundColor: '#fff',
                        '& .MuiFormControl-root': { width: '100%' },
                    }}
                    onSubmit={handleSubmit}>
                    <Box>
                        <Title title="Add Event Documents" />
                    </Box>
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'column', lg: 'row' },
                                padding: 0,
                                flex: 1,
                                marginTop: 1,
                            }}>

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    flex: 0.5,
                                    alignItems: 'center',
                                    padding: 1,
                                }}>
                                <TextField
                                    required={true}
                                    size="small"
                                    id="outlined-required"
                                    label="Resource Name"
                                    autoComplete="off"
                                    onBlur={validateFName}
                                    value={state.ResourceName.get()}
                                    onChange={(event) =>
                                    {
                                        state.ResourceName.set(event.target.value),
                                            setResourceNameErr('');
                                        handleDisableBtn();
                                    }}
                                    error={
                                        ResourceNameErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        ResourceNameErr.length > 0
                                            ? ResourceNameErr
                                            : ''
                                    }
                                    // sx={{ marginTop: ResourceNameErr.length > 0 ? "25px" : "" }}
                                    inputProps={{ maxLength: 50 }}
                                />
                            </Box>

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    flex: 0.5,
                                    alignItems: 'center',
                                    padding: 1,
                                    marginBottom: ResourceNameErr.length > 0 ? "25px" : ""
                                }}>
                                <Select
                                    size="small"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={state.IsPublic.get()}
                                    label="Access"
                                    onChange={(event) =>
                                    {
                                        state.IsPublic.set(event.target.value);
                                        handleDisableBtn();
                                    }
                                    }
                                    sx={{ width: 300 }}
                                >
                                    <MenuItem value={1}>
                                        <PublicOutlinedIcon sx={{ position: 'absolute' }} fontSize="small" color="primary" />
                                        <Typography ml={3}>Public</Typography>
                                    </MenuItem>
                                    <MenuItem value={0}>
                                        <LockOutlinedIcon sx={{ position: 'absolute' }} fontSize="small" color="primary" />
                                        <Typography ml={3}> Private</Typography>
                                    </MenuItem>
                                </Select>
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: {
                                        xs: 'column',
                                        md: 'row',
                                    },
                                    padding: 0,
                                    flex: 1,
                                    marginBottom: ResourceNameErr.length > 0 ? "25px" : ""

                                }}>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        flex: 0.5,
                                        alignItems: 'center',
                                        padding: 1,
                                    }}>
                                    <Box
                                        component="span"
                                        alt="pic."
                                        className={classes.pic}
                                        id="imageUpload"
                                    >
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={onResourceButtonClick}
                                        >
                                            Add Documents
                                        </Button>
                                    </Box>
                                </Box>
                                {/* {(state.src.get() !== "") ? ( */}
                                {/* <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        flex: 0.5,
                                        alignItems: 'center',
                                        padding: 1,
                                    }}>

                                    {fileNameArr && fileNameArr.map((item, key) =>
                                    {
                                        return (
                                            <Box key={key}
                                                sx={{
                                                    flexDirection: 'column',
                                                    flex: 0.5,
                                                    alignItems: 'center',
                                                    padding: 1,
                                                }}>
                                                <Typography
                                                >{item.fileName}</Typography>
                                            </Box>
                                        )

                                    })}
                                </Box> */}

                                {/* ) : ""} */}
                            </Box>
                            <input
                                type="file"
                                id="imageUploadFile"
                                accept="application/pdf"
                                hidden
                                // multiple={true}
                                ref={inputFile}
                                onChange={fileUploadHandler}
                            />
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: {
                                xs: 'column',
                                md: 'row',
                            },
                            pl: 1,
                            flex: 1,
                        }}>
                            <Typography
                                variant="h4"
                                fontSize={14}
                                sx={{ pb: 1, color: 'red' }}
                                fontWeight={400}
                            >
                                Only pdf files are required
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: {
                                    xs: 'column',
                                    md: 'row',
                                },
                                padding: 0,
                                flex: 1, 
                            }}>
                            <Typography
                                variant="h2"
                                fontSize={14}
                                fontWeight={500}
                                paddingLeft={1}
                                paddingTop={1} 
                                color={'primary'}
                                pb={1}>
                                Description 
                            </Typography>
                        </Box>
                        <Box 
                            component="div"
                            sx={{ 
                                padding: 0, 
                                width: { xs: '100%', md: '100%' },
                                pb:3,
                                pl:1
                            }}
                        >
                            <TinyMCEEditor
                                value={state.Description.attach(Downgraded).get()}
                                setValue={setEditorValue}                
                            />
                            {/* <CKEditor
                                editor={Editor}
                                config={{
                                    image: {
                                        upload: ['jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff']
                                    }, 
                                    enterMode: 3
                                }}
                                data={state.Description.attach(Downgraded).get()}
                                onChange={(event, editor) => {
                                    console.log(event);
                                    state.Description.set(editor.getData())
                                    handleDisableBtn();
                                }}
                            /> */}
                        </Box>
                    </>
                    {/* <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            flex: 0.5,
                            alignItems: 'center',
                            padding: 1,
                        }}> */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            flex: 1,
                            marginTop: 1,
                            backgroundColor: '#f8f8f8',
                        }}>
                        <Box
                            flex={0.3}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'start',
                                lineHeight: '0',
                            }}>
                            <Typography
                                variant="h2"
                                fontSize={12}
                                fontWeight={500}
                                paddingLeft={1}
                                paddingTop={1}
                                sx={{ paddingLeft: 5 }}
                                color={'primary'}
                                pb={1}>
                                File Name
                            </Typography>
                        </Box>
                        {/* <Box
                            flex={0.3}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'start',
                                lineHeight: '0',
                            }}>
                            <Typography
                                variant="h2"
                                fontSize={12}
                                fontWeight={500}
                                paddingLeft={1}
                                paddingTop={1}
                                sx={{ paddingLeft: 5 }}
                                color={'primary'}
                                pb={1}>
                                Created Date
                            </Typography>
                        </Box> */}
                    </Box>
                    {state.resourceFile.attach(Downgraded).get() &&
                        state.resourceFile
                            .attach(Downgraded)
                            .get()
                            .map((item, key) =>
                            {
                                return (
                                    <Box
                                        key={key}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            flex: 1,
                                            marginTop: 1,
                                            backgroundColor: '#f8f8f8',
                                        }}>
                                        <Box
                                            flex={0.3}
                                            sx={{
                                                // display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'start',
                                                lineHeight: '0',
                                                display: 'inline-block',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                maxWidth: '40ch',
                                            }}>
                                            <Typography
                                                variant="h2"
                                                fontSize={14}
                                                fontWeight={400}
                                                paddingLeft={1}
                                                paddingTop={1}
                                                sx={{ paddingLeft: 5 }}
                                                pb={1}>
                                                {item.fileName}
                                            </Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                flex: 0.05,
                                            }}>
                                            <Box
                                                component="img"
                                                className={
                                                    classes.sedanBlack
                                                }
                                                alt="logo."
                                                src={trash}
                                                onClick={() =>
                                                    handleEditRemove(key)
                                                }
                                            />
                                        </Box>
                                    </Box>

                                )

                            })}
                    {state.src.attach(Downgraded).get() && state.src.attach(Downgraded).get().map((item, key) =>
                    {
                        return (
                            <Box
                                key={key}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    flex: 1,
                                    marginTop: 1,
                                    backgroundColor: '#f8f8f8',
                                }}>
                                <Box
                                    flex={0.3}
                                    sx={{
                                        // display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'start',
                                        lineHeight: '0',
                                        display: 'inline-block',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '40ch',
                                    }}>
                                    <Typography
                                        variant="h2"
                                        fontSize={14}
                                        fontWeight={400}
                                        paddingLeft={1}
                                        paddingTop={1}
                                        sx={{ paddingLeft: 5 }}
                                        pb={1}>
                                        {item.fileName}
                                    </Typography>
                                </Box>
                                {/* <Box
                                    flex={0.3}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'start',
                                        lineHeight: '0',
                                    }}>
                                    <Typography
                                        variant="h2"
                                        fontSize={14}
                                        fontWeight={400}
                                        paddingLeft={1}
                                        paddingTop={1}
                                        sx={{ paddingLeft: 5 }}
                                        pb={1}>
                                        {`${Helper.FormatYearDate(
                                            new Date()
                                        )} ${Helper.FormatTime24(
                                            new Date()
                                        )}`}
                                    </Typography>
                                </Box> */}
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        flex: 0.05,
                                    }}>
                                    <Box
                                        component="img"
                                        className={
                                            classes.sedanBlack
                                        }
                                        alt="logo."
                                        src={trash}
                                        onClick={() =>
                                            handleRemove(key)
                                        }
                                    />
                                </Box>
                            </Box>

                        )

                    })}
                    {/* </Box> */}
                    <Divider component="div" sx={{ mt: 2 }} />
                    <ButtonContainer
                        handleCancel={handleBtnCancel}
                        buttonText={eventResourceID > 0 ? 'Update' : 'Create'}
                        disableButton={state.isDisable.get()}
                        disableUpdateButton={eventResourceID > 0 ? disableBtn : false}
                    />

                    {snackBarProps.openSnack && (
                        <CustomizedSnackbars
                            {...snackBarProps}
                            onClose={() =>
                                setSnackBarProps({
                                    ...snackBarProps,
                                    openSnack: false,
                                })
                            }></CustomizedSnackbars>
                    )}
                </Box>
            )}

        </>
    );
};
export default {
    routeProps: {
        path: [
            RouteConstants.CREATE_EVENT_RESOURCE,
            RouteConstants.EDIT_EVENT_RESOURCE,
        ],
        component: CreateResource,
    },
    name: 'CreateResource',
};
